import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';

const columns: ColumnSettings[] = [
  {
    name: 'name',
    title: 'Name',
    sortable: true,
  },
];

const CollegeMajors = (): React.ReactElement => (
  <div>
    <h1 className="shared-font headline">College Majors</h1>
    <EditableTable
      basePath="/v1/admin/college-majors"
      defaultSortKey="name"
      columns={columns}
      identifier="college-majors"
    />
  </div>
);

export default CollegeMajors;
